<template>

  <div style="height: 100%; padding-top: 20px" class="bg">
    <a-row style="height: 100%">
      <a-col :span="3" class="left_bg">
        <div class="dcblist">
          <ul>
            <li class="title">电池包列表</li>
            <li class="on">Pack0</li>
            <li>Pack1</li>
            <li>Pack2</li>
          </ul>
        </div>
      </a-col>
      <a-col :span="17">
        <div class="zbg" style="height:200px">

          <a-row>
            <a-col :span="12">
              <h1 class="biaoti">电池包信息</h1>
              <a-row style="margin-top:30px">
                <a-col :span="3">

                  <h2 class="dcnum">{{ batteryData ? batteryData.duration : '-' }}<span>天</span></h2>
                  <h1 class="dctitle">开路时长</h1>
                </a-col>
                <a-col :span="4">

                  <h2 class="dcnum">{{ batteryData ? batteryData.heating : '-' }}</h2>
                  <h1 class="dctitle">加热开关</h1>
                </a-col>
                <a-col :span="4">

                  <h2 class="dcnum">{{ batteryData ? batteryData.pressure : '-' }}<span>V</span></h2>
                  <h1 class="dctitle">均衡压差</h1>
                </a-col>
                <a-col :span="3">

                  <h2 class="dcnum">{{ batteryData ? batteryData.current : '-' }}<span>A</span></h2>
                  <h1 class="dctitle">电流</h1>
                </a-col>
                <a-col :span="3">

                  <h2 class="dcnum">{{ batteryData ? batteryData.vol : '-' }}<span>V</span></h2>
                  <h1 class="dctitle">电压</h1>
                </a-col>
                <a-col :span="4">

                  <h2 class="dcnum">{{ batteryData ? batteryData.aVol : '-' }}<span>V</span></h2>
                  <h1 class="dctitle">单体平均电压</h1>
                </a-col>
                <a-col :span="3">

                  <h2 class="dcnum">{{ batteryData ? '正常' : '离线' }}</h2>
                  <h1 class="dctitle">状态</h1>
                </a-col>
              </a-row>
            </a-col>
            <a-col :span="6">
              <h1 class="biaoti">PACK包温度</h1>
              <a-row style="margin-top:30px">
                <a-col :span="6">

                  <div class="dcbg">
                    <h2 class="dcnum2">{{ batteryData ? batteryData.tp1 : '-' }}<span> °C</span></h2>
                  </div>
                  <h1 class="dctitle2"><img src="@/assets/wendu.jpg" style="margin-right:6px">温度1</h1>
                </a-col>
                <a-col :span="6">

                  <div class="dcbg">
                    <h2 class="dcnum2">{{ batteryData ? batteryData.tp2 : '-' }}<span> °C</span></h2>
                  </div>
                  <h1 class="dctitle2"><img src="@/assets/wendu.jpg" style="margin-right:6px">温度2</h1>
                </a-col>
                <a-col :span="6">

                  <div class="dcbg">
                    <h2 class="dcnum2">{{ batteryData ? batteryData.tp3 : '-' }}<span> °C</span></h2>
                  </div>
                  <h1 class="dctitle2"><img src="@/assets/wendu.jpg" style="margin-right:6px">温度3</h1>
                </a-col>
                <a-col :span="6">

                  <div class="dcbg">
                    <h2 class="dcnum2">{{ batteryData ? batteryData.tp4 : '-' }}<span> °C</span></h2>
                  </div>
                  <h1 class="dctitle2"><img src="@/assets/wendu.jpg" style="margin-right:6px">温度4</h1>
                </a-col>
              </a-row>
            </a-col>
            <a-col :span="6">
              <h1 class="biaoti">PACK包均衡温度</h1>
              <a-row style="margin-top:30px">
                <a-col :span="6">

                  <div class="dcbg">
                    <h2 class="dcnum2">{{ batteryData ? batteryData.bTp1 : '-' }}<span> °C</span></h2>

                  </div>
                  <h1 class="dctitle2">均衡温度1</h1>
                </a-col>
                <a-col :span="6">

                  <div class="dcbg">
                    <h2 class="dcnum2">{{ batteryData ? batteryData.bTp2 : '-' }}<span> °C</span></h2>
                  </div>
                  <h1 class="dctitle2">均衡温度2</h1>
                </a-col>
              </a-row>
            </a-col>
          </a-row>

        </div>
        <div style="margin-top:260px"></div>
        <div class="zbg" style="height:320px">
          <div style="display:flex; justify-content:space-between">
            <h1 class="biaoti">单体电池数据</h1>
            <p style="color:#00e1e4;padding-right:40px">报告导出</p>
          </div>
          <div>

            <table class="shuju">
              <tr class="trbg">
                <td></td>
                <td>单体1</td>
                <td>单体2</td>
                <td>单体3</td>
                <td>单体4</td>
                <td>单体5</td>
                <td>单体6</td>
                <td>单体7</td>
                <td>单体8</td>
                <td>单体9</td>
                <td>单体10</td>
                <td>单体11</td>
                <td>单体12</td>
                <td>单体13</td>
                <td>单体14</td>
                <td>单体15</td>
                <td>单体16</td>
              </tr>
              <tr>
                <td style="background: #04203c">单体电压（V）</td>
                <td class="tdbg">{{ batteryData ? batteryData.vol1 : '-' }}</td>
                <td class="tdbg">{{ batteryData ? batteryData.vol2 : '-' }}</td>
                <td class="tdbg">{{ batteryData ? batteryData.vol3 : '-' }}</td>
                <td class="tdbg">{{ batteryData ? batteryData.vol4 : '-' }}</td>
                <td class="tdbg">{{ batteryData ? batteryData.vol5 : '-' }}</td>
                <td class="tdbg">{{ batteryData ? batteryData.vol6 : '-' }}</td>
                <td class="tdbg">{{ batteryData ? batteryData.vol7 : '-' }}</td>
                <td class="tdbg">{{ batteryData ? batteryData.vol8 : '-' }}</td>
                <td class="tdbg">{{ batteryData ? batteryData.vol9 : '-' }}</td>
                <td class="tdbg">{{ batteryData ? batteryData.vol10 : '-' }}</td>
                <td class="tdbg">{{ batteryData ? batteryData.vol11 : '-' }}</td>
                <td class="tdbg">{{ batteryData ? batteryData.vol12 : '-' }}</td>
                <td class="tdbg">{{ batteryData ? batteryData.vol13 : '-' }}</td>
                <td class="tdbg">{{ batteryData ? batteryData.vol14 : '-' }}</td>
                <td class="tdbg">{{ batteryData ? batteryData.vol15 : '-' }}</td>
                <td class="tdbg">{{ batteryData ? batteryData.vol16 : '-' }}</td>
              </tr>
              <tr>
                <td style="background: #04203c">均衡容量（Ah）</td>
                <td class="tdbg">{{ batteryData ? batteryData.BAh1 : '-' }}</td>
                <td class="tdbg">{{ batteryData ? batteryData.BAh2 : '-' }}</td>
                <td class="tdbg">{{ batteryData ? batteryData.BAh3 : '-' }}</td>
                <td class="tdbg">{{ batteryData ? batteryData.BAh4 : '-' }}</td>
                <td class="tdbg">{{ batteryData ? batteryData.BAh5 : '-' }}</td>
                <td class="tdbg">{{ batteryData ? batteryData.BAh6 : '-' }}</td>
                <td class="tdbg">{{ batteryData ? batteryData.BAh7 : '-' }}</td>
                <td class="tdbg">{{ batteryData ? batteryData.BAh8 : '-' }}</td>
                <td class="tdbg">{{ batteryData ? batteryData.BAh9 : '-' }}</td>
                <td class="tdbg">{{ batteryData ? batteryData.BAh10 : '-' }}</td>
                <td class="tdbg">{{ batteryData ? batteryData.BAh11 : '-' }}</td>
                <td class="tdbg">{{ batteryData ? batteryData.BAh12 : '-' }}</td>
                <td class="tdbg">{{ batteryData ? batteryData.BAh13 : '-' }}</td>
                <td class="tdbg">{{ batteryData ? batteryData.BAh14 : '-' }}</td>
                <td class="tdbg">{{ batteryData ? batteryData.BAh15 : '-' }}</td>
                <td class="tdbg">{{ batteryData ? batteryData.BAh16 : '-' }}</td>
              </tr>
              <tr>
                <td style="background: #04203c">均衡电量（Wh）</td>
                <td class="tdbg">{{ batteryData ? batteryData.BWh1 : '-' }}</td>
                <td class="tdbg">{{ batteryData ? batteryData.BWh2 : '-' }}</td>
                <td class="tdbg">{{ batteryData ? batteryData.BWh3 : '-' }}</td>
                <td class="tdbg">{{ batteryData ? batteryData.BWh4 : '-' }}</td>
                <td class="tdbg">{{ batteryData ? batteryData.BWh5 : '-' }}</td>
                <td class="tdbg">{{ batteryData ? batteryData.BWh6 : '-' }}</td>
                <td class="tdbg">{{ batteryData ? batteryData.BWh7 : '-' }}</td>
                <td class="tdbg">{{ batteryData ? batteryData.BWh8 : '-' }}</td>
                <td class="tdbg">{{ batteryData ? batteryData.BWh9 : '-' }}</td>
                <td class="tdbg">{{ batteryData ? batteryData.BWh10 : '-' }}</td>
                <td class="tdbg">{{ batteryData ? batteryData.BWh11 : '-' }}</td>
                <td class="tdbg">{{ batteryData ? batteryData.BWh12 : '-' }}</td>
                <td class="tdbg">{{ batteryData ? batteryData.BWh13 : '-' }}</td>
                <td class="tdbg">{{ batteryData ? batteryData.BWh14 : '-' }}</td>
                <td class="tdbg">{{ batteryData ? batteryData.BWh15 : '-' }}</td>
                <td class="tdbg">{{ batteryData ? batteryData.BWh16 : '-' }}</td>
              </tr>
            </table>
          </div>
        </div>
      </a-col>
      <a-col :span="4">
        <DetailRight />

      </a-col>
    </a-row>
  </div>
</template>

<script>
//import http from "@/api/http";
import { defineComponent, onMounted, ref } from "vue";

import DetailRight from "./dianchi/DetailRight.vue";
import mqtt from '@/api/mqtt';
//import { useStore } from "vuex";
export default defineComponent({
  name: "DianChi",
  components: {
    DetailRight,

  },
  props: {},
  setup() {
    // const store = useStore()
    // let stationid = store.getters['User/stationid']
    const getData = () => {
      // http.get("/battery_package/" + stationid + "/0").then((res) => {
      //   console.log(res)

      // });
    };

    onMounted(() => {
      //组件挂载时的生命周期执行的方法

      getData();
    });
    //单体电池数据
    const batteryData = ref(null);
    //读取Mqtt实时消息
    mqtt.subscribe("device/+/pack", (message) => {
      console.log("收到消息", message)
      batteryData.value = message;
    })
    return {
      getData,
      batteryData
    };
  },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.dcblist {
  padding-top: 30px;
  padding-left: 30px;
  padding-right: 30px;
}


.left_bg {
  background: url("@/assets/bjk.png");
  background-size: 100% 100%;
}

.bg {
  background: url("@/assets/bg22.png");
  background-size: 100% 100%;

}

.zbg {
  background: url("@/assets/bjk5.png");
  background-size: 100% 100%;
  margin: 0 40px;
  padding: 20px;
}

.biaoti {
  background: url("@/assets/biaoti.png") no-repeat;
  margin: 0 0px;
  padding-left: 28px;
  color: #fff;
  font-size: 14px;
  font-weight: bold;
  width: 288px;
}

.shuju {
  width: 100%;
  margin-top: 15px;
}

.trbg {
  background-color: #04203c;
}

.tdbg {
  background-color: #04203c;
}

.shuju tr td {
  text-align: center;
  color: #fff;
  line-height: 45px;
  border: 1px #2b85e4 solid;
}

.dctitle {
  font-size: 14px;
  color: #fff;
}

.dctitle2 {
  font-size: 12px;
  color: #fff;
}

.dcnum2 {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 20px;
  color: #1e91ff;
  display: flex;
}

.dcnum2 span {
  color: #1e91ff;
  font-size: 14px;
  padding-left: 2px;
  font-weight: bold;
}

.dcnum {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 24px;
  color: #1e91ff;
}

.dcnum span {
  color: #1e91ff;
  font-size: 14px;
  padding-left: 2px;
  font-weight: bold;
}

.dcblist .title {
  padding-left: 20px;
  font-size: 18px;
  font-weight: bold;
  background-color: transparent;
}

.dcbg {



  padding-top: 10px;

}

.dcblist ul li {
  line-height: 60px;
  color: #fff;
  list-style: none;
  background-color: #234c70;
  margin-bottom: 2px;
  padding-left: 20px;
}

.dcblist ul li.on {
  background-color: #2489ff;
  border-left: 1px #66bbf9 solid;
}

.daochu {
  background-color: #1d5fa3;
  color: #fff;
  height: 30px;
  line-height: 30px;
  padding: 0px 10px 2px;
  border: 1px #409eff solid;
  margin-left: 50px;
}
</style>
